import Vue from "vue";
import store from "../store/store.js";
import VueRouter from "vue-router";
import routes from "../routes";
import { Role } from "./_helper";

function lazyLoad(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/views/${view}.vue`)
}
function lazyLoadComponent(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/components/${view}.vue`)
}

Vue.use(VueRouter);

const all_routes = routes.concat([
  {
    path: '/',
    name: 'home',
    component: lazyLoad("Home"),
    meta: { authorize: [Role.Admin, Role.ComplianceStaff, Role.ComplianceStudent], requiresAuth: true }, 
    children: [
      {
        path: '',
        name: 'SidePanel',
        component: lazyLoadComponent('sidesheet/SidePanel'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: lazyLoadComponent("auth/Login"),
    meta: { authorize: [] },
  },
  {
    path: "/pwd-reset",
    name: "ResetPassword",
    component: lazyLoadComponent("auth/ResetPassword"),
    meta: { authorize: [] },
  },
  {
    path: "/edit-profile",
    name: "EditProfile",
    component: lazyLoadComponent("user/EditProfile"),
    meta: { authorize: [], requiresAuth: true},
  },
]);


const router = new VueRouter({
  routes: all_routes,
});

function isAuthorized(authorize){
  if(!authorize || authorize.length < 1){
    return true;
  }

  let hasModule = false;
  const userModules = store.getters['auth/userModules'];
  if(userModules && userModules.length > 0){
    hasModule = userModules.some(m => m && m.path === process.env.VUE_APP_MODULE);
  }

  const userRoles = store.getters['auth/userRoles'];
  if(hasModule && userRoles && userRoles.length > 0){
    return userRoles.some(r => authorize.includes(r));
  }
  else{
    store.dispatch("messages/addErrorMessage", 'Unauthorized Access', {root:true});
    return false;
  }

}

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.path.startsWith('/secure/') || record.meta.requiresAuth)) {
    const { authorize } = to.meta;

    if (store.getters['auth/isLoggedIn']) {
      //is logged in and has authorized permission
      if(isAuthorized(authorize)){
        next()
        return
      }
      else{
        //Is logged in, but not authorized
        store.dispatch("auth/processLogout", null, {root:true});
        next({
          path: '/login',
          query: { redirect: to.fullPath, msg: 'Unauthorized Access' }
        })
      }
    }
    //not logged in
    else{
      //Check if jwt token exists and attempt to automatically log in
      store.dispatch("auth/remoteJwtTokenCheck", null, {root:true})
        .then( () => {
          //check if user is authorized
          if(isAuthorized(authorize)){
            next()
          }
          else{
            //not authorized
            store.dispatch("auth/processLogout", null, {root:true});
            next({
              path: '/login',
              query: { redirect: to.fullPath }
            })
          }
        })
        .catch( () => {
          // console.log('fail jwt token check')
          store.dispatch("auth/processLogout", null, {root:true});
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        })
    }
  } else {
    //accessing non-secured page
    next()
  }
})

export default router;
